import React from "react";
import { Activity } from "lucide-react";

interface LoadingScreenProps {
  message?: string;
  role: "admin" | "doctor";
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ message = "Préparation des données...", role }) => (
  <div
    className={`min-h-screen flex items-center justify-center ${
      role === "admin" ? "bg-gradient-to-br from-slate-50 via-white to-slate-100" : "bg-gray-50"
    }`}
  >
    <div className="text-center">
      <div className="relative">
        <div
          className={`w-20 h-20 ${
            role === "admin" ? "bg-gradient-to-r from-blue-500 to-purple-600" : "bg-indigo-600"
          } rounded-full flex items-center justify-center mb-4 mx-auto animate-pulse`}
        >
          <Activity className="w-8 h-8 text-white" />
        </div>
        {role === "admin" && (
          <div className="absolute inset-0 w-20 h-20 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full animate-ping opacity-20 mx-auto"></div>
        )}
      </div>
      <h2 className="text-xl font-semibold text-gray-800 mb-2">Chargement des données</h2>
      <p className="text-gray-600">{message}</p>
    </div>
  </div>
);

export default LoadingScreen;